// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* action button */
.action-button {
  width: 32px !important;
  height: 32px !important;
  padding: 0;
  border-radius: 8px;
  border-width: 0;
  color: var(--gray-60);
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.action-button-lg {
  width: 40px !important;
  height: 40px !important;
  padding: 0;
  border-radius: 8px;
  border-width: 0;
  color: var(--gray-60);
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.action-button-sm {
  width: 24px !important;
  height: 24px !important;
  padding: 0;
  border-radius: 6px;
  border-width: 0;
  color: var(--gray-60);
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.action-button-xs {
  width: 20px !important;
  height: 20px !important;
  padding: 0;
  border-radius: 4px;
  border-width: 0;
  color: var(--gray-60);
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.action-button:focus,
.action-button-lg:focus,
.action-button-sm:focus,
.action-button-xs:focus {
  color: var(--blue-100) !important;
  background-color: var(--gray-1) !important;
  box-shadow: none !important;
}
.action-button:not(.p-disabled):hover,
.action-button-lg:not(.p-disabled):hover,
.action-button-sm:not(.p-disabled):hover,
.action-button-xs:not(.p-disabled):hover {
  color: var(--gray-80) !important;
  background-color: var(--gray-1) !important;
}
.p-datatable.clickable-row .p-datatable-tbody .action-button:not(.p-disabled):hover,
.p-datatable.clickable-row .p-datatable-tbody .action-button-lg:not(.p-disabled):hover,
.p-datatable.clickable-row .p-datatable-tbody .action-button-sm:not(.p-disabled):hover,
.p-datatable.clickable-row .p-datatable-tbody .action-button-xs:not(.p-disabled):hover {
  background-color: var(--primary-white) !important;
}
.action-button.action-button-dark {
  color: var(--primary-white);
}
.action-button.action-button-dark:focus {
  color: var(--primary-white) !important;
  background-color: var(--gray-80) !important;
}
.action-button.action-button-dark:hover {
  color: var(--primary-white) !important;
  background-color: var(--gray-80) !important;
}

.hidden-button-container .action-button,
.hidden-button-container .action-button-lg,
.hidden-button-container .action-button-sm,
.hidden-button-container .action-button-xs {
  visibility: hidden;
}
.hidden-button-container:hover .action-button,
.hidden-button-container:hover .action-button-lg,
.hidden-button-container:hover .action-button-sm,
.hidden-button-container:hover .action-button-xs {
  visibility: visible;
}

.ghost-button-container .action-button,
.ghost-button-container .action-button-lg,
.ghost-button-container .action-button-sm,
.ghost-button-container .action-button-xs {
  display: none;
}
.ghost-button-container:hover .action-button,
.ghost-button-container:hover .action-button-lg,
.ghost-button-container:hover .action-button-sm,
.ghost-button-container:hover .action-button-xs {
  display: flex;
}

/* add button */
.add-button {
  height: 16px;
  padding: 0;
  border-radius: 4px;
  border-width: 0;
  color: var(--gray-60);
  background-color: var(--gray-10);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-button:not(.p-disabled):hover {
  color: var(--blue-100) !important;
  background-color: var(--blue-20) !important;
}
.add-button.p-invalid {
  color: var(--primary-white) !important;
  background-color: var(--red-100) !important;
}
.add-button.p-invalid:hover {
  color: var(--primary-white) !important;
  background-color: var(--red-dark) !important;
}

/* dropdown-button */
.dropdown-button {
  border: none;
  background: transparent;
  height: 32px;
  border-radius: 8px;
  color: var(--gray-60);
}
.dropdown-button .p-dropdown-label.p-inputtext {
  color: var(--gray-60);
  padding: 7px 18px;
  visibility: visible;
  background: transparent;
}
.dropdown-button:enabled:hover,
.dropdown-button:not(.p-disabled):hover,
.dropdown-button:enabled:active,
.dropdown-button:active,
.dropdown-button:focus {
  background: var(--blue-4);
  box-shadow: none;
}
.dropdown-button:enabled:hover .p-dropdown-label.p-inputtext,
.dropdown-button:not(.p-disabled):hover .p-dropdown-label.p-inputtext,
.dropdown-button:enabled:active .p-dropdown-label.p-inputtext,
.dropdown-button:active .p-dropdown-label.p-inputtext,
.dropdown-button:focus .p-dropdown-label.p-inputtext {
  color: var(--gray-60);
}
.dropdown-button .p-dropdown-trigger {
  display: none;
}

/* dropdown right panel */
.dropdown-right-panel {
  left: auto !important;
  right: 36px !important;
}
.dropdown-right-panel {
  transform-origin: top right;
}

/* attendee-email */
.attendee-email {
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.005rem;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* truncate  */
.truncate {
  text-overflow: ellipsis;
  overflow-x: clip;
  white-space: nowrap;
}

/* login page */
.login-password-input-wrapper {
  position: relative;
}

.login-password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-password-toggle:hover {
  opacity: 0.7;
}

.login-password-toggle:focus {
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/css/sumoCustom.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;;EAIE,iCAAiC;EACjC,0CAA0C;EAC1C,2BAA2B;AAC7B;AACA;;;;EAIE,gCAAgC;EAChC,0CAA0C;AAC5C;AACA;;;;EAIE,iDAAiD;AACnD;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,sCAAsC;EACtC,2CAA2C;AAC7C;AACA;EACE,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;;;;EAIE,kBAAkB;AACpB;AACA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;EAIE,aAAa;AACf;AACA;;;;EAIE,aAAa;AACf;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iCAAiC;EACjC,2CAA2C;AAC7C;AACA;EACE,sCAAsC;EACtC,2CAA2C;AAC7C;AACA;EACE,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;;;EAKE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;;;;;EAKE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* action button */\n.action-button {\n  width: 32px !important;\n  height: 32px !important;\n  padding: 0;\n  border-radius: 8px;\n  border-width: 0;\n  color: var(--gray-60);\n  background-color: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.action-button-lg {\n  width: 40px !important;\n  height: 40px !important;\n  padding: 0;\n  border-radius: 8px;\n  border-width: 0;\n  color: var(--gray-60);\n  background-color: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.action-button-sm {\n  width: 24px !important;\n  height: 24px !important;\n  padding: 0;\n  border-radius: 6px;\n  border-width: 0;\n  color: var(--gray-60);\n  background-color: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.action-button-xs {\n  width: 20px !important;\n  height: 20px !important;\n  padding: 0;\n  border-radius: 4px;\n  border-width: 0;\n  color: var(--gray-60);\n  background-color: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.action-button:focus,\n.action-button-lg:focus,\n.action-button-sm:focus,\n.action-button-xs:focus {\n  color: var(--blue-100) !important;\n  background-color: var(--gray-1) !important;\n  box-shadow: none !important;\n}\n.action-button:not(.p-disabled):hover,\n.action-button-lg:not(.p-disabled):hover,\n.action-button-sm:not(.p-disabled):hover,\n.action-button-xs:not(.p-disabled):hover {\n  color: var(--gray-80) !important;\n  background-color: var(--gray-1) !important;\n}\n.p-datatable.clickable-row .p-datatable-tbody .action-button:not(.p-disabled):hover,\n.p-datatable.clickable-row .p-datatable-tbody .action-button-lg:not(.p-disabled):hover,\n.p-datatable.clickable-row .p-datatable-tbody .action-button-sm:not(.p-disabled):hover,\n.p-datatable.clickable-row .p-datatable-tbody .action-button-xs:not(.p-disabled):hover {\n  background-color: var(--primary-white) !important;\n}\n.action-button.action-button-dark {\n  color: var(--primary-white);\n}\n.action-button.action-button-dark:focus {\n  color: var(--primary-white) !important;\n  background-color: var(--gray-80) !important;\n}\n.action-button.action-button-dark:hover {\n  color: var(--primary-white) !important;\n  background-color: var(--gray-80) !important;\n}\n\n.hidden-button-container .action-button,\n.hidden-button-container .action-button-lg,\n.hidden-button-container .action-button-sm,\n.hidden-button-container .action-button-xs {\n  visibility: hidden;\n}\n.hidden-button-container:hover .action-button,\n.hidden-button-container:hover .action-button-lg,\n.hidden-button-container:hover .action-button-sm,\n.hidden-button-container:hover .action-button-xs {\n  visibility: visible;\n}\n\n.ghost-button-container .action-button,\n.ghost-button-container .action-button-lg,\n.ghost-button-container .action-button-sm,\n.ghost-button-container .action-button-xs {\n  display: none;\n}\n.ghost-button-container:hover .action-button,\n.ghost-button-container:hover .action-button-lg,\n.ghost-button-container:hover .action-button-sm,\n.ghost-button-container:hover .action-button-xs {\n  display: flex;\n}\n\n/* add button */\n.add-button {\n  height: 16px;\n  padding: 0;\n  border-radius: 4px;\n  border-width: 0;\n  color: var(--gray-60);\n  background-color: var(--gray-10);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.add-button:not(.p-disabled):hover {\n  color: var(--blue-100) !important;\n  background-color: var(--blue-20) !important;\n}\n.add-button.p-invalid {\n  color: var(--primary-white) !important;\n  background-color: var(--red-100) !important;\n}\n.add-button.p-invalid:hover {\n  color: var(--primary-white) !important;\n  background-color: var(--red-dark) !important;\n}\n\n/* dropdown-button */\n.dropdown-button {\n  border: none;\n  background: transparent;\n  height: 32px;\n  border-radius: 8px;\n  color: var(--gray-60);\n}\n.dropdown-button .p-dropdown-label.p-inputtext {\n  color: var(--gray-60);\n  padding: 7px 18px;\n  visibility: visible;\n  background: transparent;\n}\n.dropdown-button:enabled:hover,\n.dropdown-button:not(.p-disabled):hover,\n.dropdown-button:enabled:active,\n.dropdown-button:active,\n.dropdown-button:focus {\n  background: var(--blue-4);\n  box-shadow: none;\n}\n.dropdown-button:enabled:hover .p-dropdown-label.p-inputtext,\n.dropdown-button:not(.p-disabled):hover .p-dropdown-label.p-inputtext,\n.dropdown-button:enabled:active .p-dropdown-label.p-inputtext,\n.dropdown-button:active .p-dropdown-label.p-inputtext,\n.dropdown-button:focus .p-dropdown-label.p-inputtext {\n  color: var(--gray-60);\n}\n.dropdown-button .p-dropdown-trigger {\n  display: none;\n}\n\n/* dropdown right panel */\n.dropdown-right-panel {\n  left: auto !important;\n  right: 36px !important;\n}\n.dropdown-right-panel {\n  transform-origin: top right;\n}\n\n/* attendee-email */\n.attendee-email {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 18px;\n  letter-spacing: 0.005rem;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n/* truncate  */\n.truncate {\n  text-overflow: ellipsis;\n  overflow-x: clip;\n  white-space: nowrap;\n}\n\n/* login page */\n.login-password-input-wrapper {\n  position: relative;\n}\n\n.login-password-toggle {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: transparent;\n  border: none;\n  padding: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.login-password-toggle:hover {\n  opacity: 0.7;\n}\n\n.login-password-toggle:focus {\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
